<template>
  <!-- 调拨出库物料列表 -->
  <div>
    <avue-crud
      :option="tableOption"
      :data="tableData"
      :page.sync="tablePage"
      :cell-style="cellStyle"
      @on-load="loadPageData"
    >
      <template slot="conversionNum" slot-scope="{ row }">
        {{ (row.conversionNum = convertGoodsUnit(row, 'inboundNum')) }}
      </template>
      <template slot="inboundPrice" slot-scope="{ row }">
        {{ tool.money_format_allowvoid((row.inboundPrice = row.price * row.inboundNum || '')) }}
      </template>
      <template slot="remark" slot-scope="{ row }">
        <el-input v-model="row.remark" maxlength="200"></el-input>
      </template>
    </avue-crud>
    <div class="sum-tips">
      <div style="color: red;">小数位数：单价2位，金额2位，超出部分将四舍五入</div>
      <div>
        合计本次入库数量：<span style="color: blue;">{{ sumNum }}</span
        >&nbsp;&nbsp; 合计金额：<span style="color: red;">{{
          tool.money_format_allowvoid(sumMoney)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getTransferGoodsListByIdApi } from '@/api/warehouse/in';
import mixin from '../mixin';

export default {
  name: 'TransferGoodsList',
  mixins: [mixin],
  props: {
    // 项目id
    projectId: {
      type: String,
      default: '',
    },
    // 调拨单id
    orderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 合计数量
      sumNum: 0,
      // 合计金额
      sumMoney: 0,
      // 总的列表数据
      listData: [],
      // 单页表格数据
      tableData: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '物料类型',
            prop: 'typeName',
          },
          {
            label: '物料编码',
            prop: 'code',
          },
          {
            label: '物料名称',
            prop: 'name',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: 'measuringUnitName',
          },
          {
            label: '单价',
            prop: 'price',
            align: 'right',
          },
          {
            label: '入库数量',
            prop: 'inboundNum',
          },
          {
            label: '换算数量',
            prop: 'conversionNum',
            slot: true,
          },
          {
            label: '本次入库金额',
            prop: 'inboundPrice',
            align: 'right',
            slot: true,
          },
          {
            label: '备注',
            prop: 'remark',
            slot: true,
          },
        ],
      },
    };
  },
  watch: {
    orderId(val) {
      this.listData = [];
      this.tableData = [];
      this.tablePage.total = 0;
      this.tablePage.currentPage = 1;
      if (val) {
        this.loadListData();
      }
    },
  },
  methods: {
    /* 表格可编辑列的样式 */
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let labels = ['备注'];
      if (labels.includes(column.label)) {
        return {
          backgroundColor: '#fffde5',
        };
      }
    },
    /* 加载列表数据 */
    loadListData() {
      getTransferGoodsListByIdApi(
        Object.assign({
          id: this.orderId,
        })
      ).then(({ data }) => {
        this.listData = data;
        // 入库数量这个字段统一名称，否则表单页面还需要区别处理
        this.listData.forEach((item) => {
          item.inboundNum = item.outboundNum || 0;
        });
        this.tablePage.total = this.listData.length;
        this.tablePage.currentPage = 1;
        this.loadPageData();
        setTimeout(this.updateSumData, 300); // 此处延迟下计算，等每一项的入库金额计算出来先
      });
    },
    /* 加载单页表格数据 */
    loadPageData() {
      if (this.listData.length == 0) return;
      let index = (this.tablePage.currentPage - 1) * this.tablePage.pageSize;
      this.tableData = this.listData.slice(index, index + this.tablePage.pageSize);
    },
    /* 计算汇总 */
    updateSumData() {
      let sumNum = 0;
      let sumMoney = 0;
      this.listData.forEach((item) => {
        sumNum += parseFloat(item.inboundNum || 0);
        sumMoney += parseFloat(item.inboundPrice || 0);
      });
      this.sumNum = sumNum;
      this.sumMoney = sumMoney;
      this.$emit('update', { list: this.listData, sumNum: this.sumNum, sumMoney: this.sumMoney });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}

.sum-tips {
  display: flex;
  justify-content: space-between;
}
</style>
